/*
  DN | Teamseite  ·  assets/dn-team.js

  Fuer sections/dn-team-members (und das Video in dn-team-cta):
  - Akkordeon je Team: Voreinstellung offen/zu kommt aus dem CSS
    (data-open-desktop / data-open-mobile), ein Klick setzt data-state.
  - Karten-Slider: Pfeile blaettern um eine sichtbare Seite, am Anfang/Ende disabled.
    Mit der Maus laesst sich die Reihe ziehen (Touch und Trackpad scrollen nativ).
  - Funfact nach Figma-Vorgabe "Team Cards · Funfact States": 2 Zeilen (mobil seit
    2026-10-23 auf Wunsch ebenfalls 2 statt 3), Schnitt nach dem letzten ganzen Wort,
    inline "… mehr lesen", aufgeklappt "weniger"; das schliessende
    Anfuehrungszeichen nur im vollen Text.
  Ohne JavaScript steht der volle Text da.

  Das Skript haengt in jeder Section-Instanz, laeuft aber nur einmal (window.DnTeam).
*/
(function () {
  if (window.DnTeam) return;

  var desktop = window.matchMedia('(min-width: 990px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Anfuehrungszeichen je Sprache aus der Section (data-quote-open/-close), sonst deutsch
  function quoteOpen(el) { return el.getAttribute('data-quote-open') || '„'; }
  function quoteClose(el) { return el.getAttribute('data-quote-close') || '“'; }
  var ELLIPSIS = '…';

  function isOpen(item) {
    var state = item.getAttribute('data-state');
    if (state) return state === 'open';
    return item.getAttribute(desktop.matches ? 'data-open-desktop' : 'data-open-mobile') === 'true';
  }

  function syncItem(item) {
    var toggle = item.querySelector('[data-dn-team-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', isOpen(item) ? 'true' : 'false');
  }

  function factButton(el, kind) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'dn-team-card__more';
    button.setAttribute('data-dn-team-fact', kind);
    button.setAttribute('aria-expanded', kind === 'less' ? 'true' : 'false');
    button.textContent = el.getAttribute(kind === 'less' ? 'data-less' : 'data-more');
    return button;
  }

  function renderFull(el, withLess) {
    el.textContent = quoteOpen(el) + el.getAttribute('data-full') + quoteClose(el);
    if (withLess) {
      el.appendChild(document.createTextNode(' '));
      el.appendChild(factButton(el, 'less'));
    }
  }

  function renderCut(el, words, count) {
    var text = words.slice(0, count).join(' ').replace(/[\s,.;:!?–—-]+$/, '');
    el.textContent = quoteOpen(el) + text + ELLIPSIS + ' ';
    el.appendChild(factButton(el, 'more'));
  }

  function clampFact(el) {
    if (!el.getAttribute('data-full')) return;
    if (el.getAttribute('data-expanded') === 'true') {
      renderFull(el, true);
      return;
    }
    renderFull(el, false);
    // Zugeklapptes Akkordeon: messen geht nicht, beim Oeffnen wird nachgeholt
    if (!el.getClientRects().length) return;

    var lineHeight = parseFloat(window.getComputedStyle(el).lineHeight) || 19.6;
    var maxHeight = lineHeight * 2 + 2;
    if (el.offsetHeight <= maxHeight) return;

    var words = el.getAttribute('data-full').split(/\s+/);
    var low = 1;
    var high = words.length - 1;
    var best = 1;
    while (low <= high) {
      var mid = (low + high) >> 1;
      renderCut(el, words, mid);
      if (el.offsetHeight <= maxHeight) {
        best = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }
    renderCut(el, words, best);
  }

  function clampWithin(root) {
    var facts = root.querySelectorAll('[data-dn-team-fact-text]');
    for (var i = 0; i < facts.length; i++) clampFact(facts[i]);
  }

  function updateNav(scope) {
    var list = scope.querySelector('[data-dn-team-list]');
    var prev = scope.querySelector('[data-dn-team-prev]');
    var next = scope.querySelector('[data-dn-team-next]');
    if (!list || !prev || !next) return;
    var max = list.scrollWidth - list.clientWidth - 1;
    list.classList.toggle('is-scrollable', max > 0);
    prev.disabled = list.scrollLeft <= 0;
    next.disabled = max <= 0 || list.scrollLeft >= max;
  }

  function scrollList(scope, direction) {
    var list = scope.querySelector('[data-dn-team-list]');
    var card = list && list.firstElementChild;
    if (!card) return;
    var gap = parseFloat(window.getComputedStyle(list).columnGap) || 0;
    var step = card.offsetWidth + gap;
    var page = Math.max(1, Math.floor((list.clientWidth + gap) / step)) * step;
    list.scrollBy({ left: direction * page, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }

  function pauseMotion(root) {
    if (!reduceMotion.matches) return;
    var videos = root.querySelectorAll('[data-dn-team-autoplay] video');
    for (var i = 0; i < videos.length; i++) {
      videos[i].pause();
      videos[i].controls = true;
    }
  }

  function init(root) {
    var items = root.querySelectorAll('[data-dn-team-item]');
    for (var i = 0; i < items.length; i++) syncItem(items[i]);
    var scopes = root.querySelectorAll('[data-dn-team-scope]');
    for (var j = 0; j < scopes.length; j++) updateNav(scopes[j]);
    clampWithin(root);
    pauseMotion(root);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-dn-team-toggle]');
    if (toggle) {
      var item = toggle.closest('[data-dn-team-item]');
      if (!item) return;
      item.setAttribute('data-state', isOpen(item) ? 'closed' : 'open');
      syncItem(item);
      if (isOpen(item)) {
        clampWithin(item);
        updateNav(item);
      }
      return;
    }

    var arrow = event.target.closest('[data-dn-team-prev], [data-dn-team-next]');
    if (arrow) {
      var scope = arrow.closest('[data-dn-team-scope]');
      if (scope) scrollList(scope, arrow.hasAttribute('data-dn-team-prev') ? -1 : 1);
      return;
    }

    var factToggle = event.target.closest('[data-dn-team-fact]');
    if (factToggle) {
      var fact = factToggle.closest('[data-dn-team-fact-text]');
      if (!fact) return;
      var expand = factToggle.getAttribute('data-dn-team-fact') === 'more';
      fact.setAttribute('data-expanded', expand ? 'true' : 'false');
      clampFact(fact);
      var focusTarget = fact.querySelector('[data-dn-team-fact]');
      if (focusTarget) focusTarget.focus();
    }
  });

  // Maus-Ziehen: Snap waehrend des Ziehens aus (.is-dragging), danach rastet die
  // naechste Karte ein. Ein Klick direkt nach dem Ziehen (z. B. auf "mehr lesen") wird verschluckt.
  var drag = null;
  var swallowClick = false;

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    var list = event.target.closest('[data-dn-team-list]');
    if (!list || list.scrollWidth <= list.clientWidth) return;
    drag = { list: list, id: event.pointerId, startX: event.clientX, startLeft: list.scrollLeft, moved: false };
  });

  document.addEventListener('pointermove', function (event) {
    if (!drag || event.pointerId !== drag.id) return;
    var dx = event.clientX - drag.startX;
    if (!drag.moved) {
      if (Math.abs(dx) < 5) return;
      drag.moved = true;
      drag.list.classList.add('is-dragging');
    }
    drag.list.scrollLeft = drag.startLeft - dx;
    event.preventDefault();
  });

  function endDrag(event) {
    if (!drag || event.pointerId !== drag.id) return;
    if (drag.moved) {
      drag.list.classList.remove('is-dragging');
      swallowClick = true;
      setTimeout(function () { swallowClick = false; }, 0);
    }
    drag = null;
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  window.addEventListener('click', function (event) {
    if (!swallowClick) return;
    swallowClick = false;
    event.preventDefault();
    event.stopPropagation();
  }, true);

  document.addEventListener('dragstart', function (event) {
    if (event.target.closest && event.target.closest('[data-dn-team-list]')) event.preventDefault();
  });

  // Sonst startet mousedown eine Textauswahl, und der Browser scrollt die Reihe
  // zum Auswahlanfang zurueck (gemessen: nach dem Ziehen wieder scrollLeft 0)
  document.addEventListener('selectstart', function (event) {
    if (drag) event.preventDefault();
  });

  // scroll blubbert nicht hoch, in der Capture-Phase kommt es trotzdem an
  document.addEventListener('scroll', function (event) {
    var list = event.target;
    if (!list.matches || !list.matches('[data-dn-team-list]')) return;
    var scope = list.closest('[data-dn-team-scope]');
    if (scope) updateNav(scope);
  }, true);

  var lastWidth = window.innerWidth;
  var resizeTimer;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { init(document); }, 150);
  }, { passive: true });

  if (desktop.addEventListener) {
    desktop.addEventListener('change', function () { init(document); });
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  window.DnTeam = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // IvyPresto/Satoshi kommen spaeter: Zeilen danach neu messen
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { clampWithin(document); });
  }
})();
